module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-tr-TR.d3ab8274.jpg";